import React, { Component } from "react";
import { Alert, Table, Typography, Space, Divider } from "antd";
import moment from "moment";
import "moment/locale/es";
import { ModalItem, ButtonItem, dineroDisabledMask } from "../../../../Components/Items";

const { Text, Title } = Typography;

//Lo que va a pasar al refacturar con "Editar insumos": sale de previsualizarEdicionInsumosRefactura,
//que arma el mismo plan que despues ejecuta refacturarVenta.
class ConfirmarEdicionInsumosRefactura extends Component {
  renderInventario(vistaPrevia) {
    const inventario = vistaPrevia.inventario || [];
    const pendientes = vistaPrevia.pendientesEntregar || [];

    return (
      <>
        <Title level={5}>Movimientos de inventario</Title>
        {inventario.length > 0 ? (
          <Table
            size="small"
            pagination={false}
            dataSource={inventario.map((valueInsumo, index) => ({ ...valueInsumo, key: "inventario-" + index }))}
            columns={[
              { title: "Insumo", dataIndex: "insumo" },
              { title: "Cantidad", dataIndex: "cantidad", align: "right" },
              { title: "Lote", dataIndex: "lote", render: (lote) => lote || "-" },
              { title: "Movimiento", dataIndex: "destino" },
              { title: "Costo unitario" + (this.sufijoMoneda(vistaPrevia) ? " (MXN)" : ""), dataIndex: "costoUnitario", align: "right", render: (valor) => dineroDisabledMask(valor) },
              { title: "Costo total" + (this.sufijoMoneda(vistaPrevia) ? " (MXN)" : ""), dataIndex: "costoTotal", align: "right", render: (valor) => dineroDisabledMask(valor) },
            ]}
          />
        ) : (
          <Text type="secondary">No regresa nada al inventario.</Text>
        )}

        {pendientes.length > 0 ? (
          <>
            <div style={{ marginTop: 10 }}>
              <Text strong>Quedarán por entregar (no se descuentan ahora):</Text>
            </div>
            <Table
              size="small"
              pagination={false}
              dataSource={pendientes.map((valueInsumo, index) => ({ ...valueInsumo, key: "pendiente-" + index }))}
              columns={[
                { title: "Insumo", dataIndex: "insumo" },
                { title: "Cantidad nueva por entregar", dataIndex: "cantidad", align: "right" },
                { title: "Total pendiente del renglón", dataIndex: "pendienteTotal", align: "right" },
              ]}
            />
          </>
        ) : null}
      </>
    );
  }

  //En una factura en otra moneda los totales y el pago van en esa moneda; pólizas e inventario en pesos
  sufijoMoneda(vistaPrevia) {
    return vistaPrevia.moneda && vistaPrevia.moneda !== "MXN" ? ` (${vistaPrevia.moneda})` : "";
  }

  renderPago(vistaPrevia) {
    const pago = vistaPrevia.pago;
    if (!pago) return null;
    const fecha = (valor) => (valor ? moment(valor).format("DD/MM/YYYY") : "-");

    return (
      <>
        <Divider style={{ margin: "15px 0" }} />
        <Title level={5}>Pago de contado</Title>
        <Table
          size="small"
          pagination={false}
          rowKey="movimiento"
          dataSource={[
            { movimiento: "Se cancela", ...pago.anterior },
            { movimiento: "Pago nuevo", ...pago.nuevo, folio: "Folio nuevo" },
          ]}
          columns={[
            { title: "", dataIndex: "movimiento", render: (valor) => <Text strong>{valor}</Text> },
            { title: "Folio", dataIndex: "folio" },
            { title: "Forma de pago", dataIndex: "formaDePago" },
            { title: "Banco", dataIndex: "banco" },
            { title: "Fecha", dataIndex: "fechaPago", render: fecha },
            { title: "Monto" + this.sufijoMoneda(vistaPrevia), dataIndex: "monto", align: "right", render: (valor) => dineroDisabledMask(valor) },
          ]}
        />
      </>
    );
  }

  renderPolizas(vistaPrevia) {
    const polizas = vistaPrevia.polizas || [];

    return (
      <>
        <Divider style={{ margin: "15px 0" }} />
        <Title level={5}>{"Contabilidad" + (this.sufijoMoneda(vistaPrevia) ? " (moneda nacional)" : "")}</Title>
        <Text type="secondary">
          Las pólizas originales de la venta no se modifican: pasan a la factura nueva. Se agregan estas pólizas de ajuste:
        </Text>
        {polizas.length === 0 ? (
          <div><Text type="secondary">No se genera ninguna póliza de ajuste.</Text></div>
        ) : null}
        {polizas.map((valuePoliza, indexPoliza) => (
          <div key={"poliza-" + indexPoliza} style={{ marginTop: 10 }}>
            <Text strong>{"Póliza de " + valuePoliza.tipo + ": " + valuePoliza.concepto}</Text>
            <Table
              size="small"
              pagination={false}
              dataSource={(valuePoliza.movimientos || []).map((valueMovimiento, index) => ({ ...valueMovimiento, key: "movimiento-" + indexPoliza + "-" + index }))}
              columns={[
                { title: "Cuenta", dataIndex: "cuenta" },
                { title: "Concepto", dataIndex: "concepto" },
                { title: "Cargo", dataIndex: "cargo", align: "right", render: (valor) => (valor ? dineroDisabledMask(valor) : "") },
                { title: "Abono", dataIndex: "abono", align: "right", render: (valor) => (valor ? dineroDisabledMask(valor) : "") },
              ]}
            />
            <div style={{ textAlign: "right", paddingRight: 8 }}>
              <Text strong>
                {"Cargos " + dineroDisabledMask(valuePoliza.totalCargos) + "  ·  Abonos " + dineroDisabledMask(valuePoliza.totalAbonos)}
              </Text>
            </div>
          </div>
        ))}
      </>
    );
  }

  renderTotales(vistaPrevia) {
    const antes = vistaPrevia.totales?.antes || {};
    const despues = vistaPrevia.totales?.despues || {};
    const renglones = [
      { concepto: "Subtotal", campo: "subtotal" },
      { concepto: "Impuestos", campo: "impuestos" },
      { concepto: "Retenciones", campo: "retenciones" },
      { concepto: "Total", campo: "total" },
      { concepto: "Total a pagar", campo: "totalPagar" },
    ];

    return (
      <>
        <Divider style={{ margin: "15px 0" }} />
        <Title level={5}>{"Totales de la factura" + this.sufijoMoneda(vistaPrevia)}</Title>
        <Table
          size="small"
          pagination={false}
          rowKey="campo"
          dataSource={renglones}
          columns={[
            { title: "", dataIndex: "concepto" },
            { title: "Antes", dataIndex: "campo", align: "right", render: (campo) => dineroDisabledMask(antes[campo] || 0) },
            { title: "Después", dataIndex: "campo", key: "despues", align: "right", render: (campo) => <Text strong>{dineroDisabledMask(despues[campo] || 0)}</Text> },
          ]}
        />
      </>
    );
  }

  render() {
    const vistaPrevia = this.props.vistaPrevia || {};
    const mensajes = vistaPrevia.mensajes || [];
    const avisos = vistaPrevia.avisos || [];

    return (
      <ModalItem
        title="Confirmar edición de insumos"
        visible={this.props.visible}
        onCancel={this.props.onRegresar}
        zIndex={this.props.zIndex}
        width="80%"
        paddingTop
        destroyOnClose
        maskClosable={false}
      >
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 15 }}
          message="Esto es lo que va a pasar al refacturar"
          description={
            <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
              <li>Se cancelará el timbre actual y se timbrará la factura nueva con estos insumos.</li>
              {mensajes.map((valueMensaje, index) => (
                <li key={index}>{valueMensaje}</li>
              ))}
            </ul>
          }
        />

        {this.renderInventario(vistaPrevia)}
        {this.renderPago(vistaPrevia)}
        {this.renderPolizas(vistaPrevia)}
        {this.renderTotales(vistaPrevia)}

        {avisos.length > 0 ? (
          <Alert
            type="info"
            showIcon
            style={{ marginTop: 15 }}
            message="Toma en cuenta"
            description={
              <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                {avisos.map((valueAviso, index) => (
                  <li key={index}>{valueAviso}</li>
                ))}
              </ul>
            }
          />
        ) : null}

        <Space style={{ marginTop: 20, marginBottom: 10, display: "flex", justifyContent: "flex-end" }}>
          <ButtonItem onClick={this.props.onRegresar}>Regresar</ButtonItem>
          <ButtonItem type="primary" verdeB onClick={this.props.onConfirmar}>
            Confirmar y Refacturar
          </ButtonItem>
        </Space>
      </ModalItem>
    );
  }
}

export default ConfirmarEdicionInsumosRefactura;
